import { Plus, Rocket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { SPRINTS } from "../mock/data";

export function TasksV2Header({
	count,
	onNewTask,
}: {
	count: number;
	onNewTask: () => void;
}) {
	const activeSprint = SPRINTS.find((s) => s.status === "active");

	return (
		<div className="mb-6 flex flex-wrap items-center justify-between gap-3">
			<div className="flex items-center gap-3">
				<h1 className="text-2xl font-bold text-foreground">Tasks</h1>
				<span className="rounded-full bg-muted-subtle px-2.5 py-0.5 text-xs font-medium text-muted">
					{count}
				</span>
				{activeSprint && (
					<Badge variant="accent" className="gap-1">
						<Rocket className="h-3 w-3" />
						{activeSprint.name}
					</Badge>
				)}
			</div>
			<div className="flex items-center gap-2">
				<Button onClick={onNewTask}>
					<Plus className="h-4 w-4" />
					New Task
				</Button>
			</div>
		</div>
	);
}
